<template>
  <div>
    <ThePageHeader :title="'Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program'" />

    <div class="text">

      <div class="text-xs-center mb-4">
        <b>Sajtóközlemény – Vállalkozásfejlesztési beruházás a Kőrös PRINT-PACK Kft.-nél</b><br>
      </div>

      <ul class="no-bullets">
        <li><strong>Kedvezményezett neve:</strong> Kőrös PRINT-PACK Nyomdaipari Csomagolástechnikai Kft.</li>
        <li><strong>A projekt címe:</strong> Technológiai és digitális fejlesztés a Kőrös PRINT-PACK Kft.-nél</li>
        <li><strong>A támogatás összege:</strong> 28 241 777 Ft</li>
        <li><strong>A támogatás mértéke:</strong> 48,71%</li>
        <li><strong>A projekt fizikai befejezési határideje:</strong> 2026. július 23.</li>
      </ul>

      <p><strong>A projekt tartalmának bemutatása:</strong></p>

      <p>
        A Kőrös PRINT-PACK Kft. a Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program keretében sikeresen valósítja meg
        technológiai és infokommunikációs fejlesztését. A projekt részeként beszerzésre kerül egy korszerű KODAK TRENDSETTER Q800
        Platesetter gép és egy KYD 1080A félautomata kitörő gép raklapemelővel, amelyek jelentősen növelik a nyomdaipari termelékenységet.
        A technológiai megújulás mellett bevezetésre kerül egy digitális munkaerő-nyilvántartási rendszer, valamint a hatékonyság
        növelése érdekében a vállalat vezetői- és menedzsment tanácsadást vesz igénybe.
      </p>

      <p>
        A beruházás a Magyarország 2025. évi központi költségvetése terhére, a Nemzetgazdasági Minisztérium támogatásával valósul meg.
      </p>

      <div class="logo-container my-4">
        <img src="/img/certificates/demjan/nemzetgazdasagi-miniszterium.png" alt="Nemzetgazdasági Minisztérium" class="ministry-logo">
      </div>

    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'DemjanProjekt',
  metaInfo: {
    title: 'Demján Sándor 1+1 KKV Program | Kőrös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: 'Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program - Kőrös PRINT-PACK Kft.',
      },
    ],
  },
  components: {
    ThePageHeader,
  },
};
</script>

<style scoped>
.text {
  margin: 100px auto 0 auto;
  width: 1000px;
  max-width: 90vw;
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
}

.no-bullets {
  list-style: none;
  padding-left: 0;
}

.logo-container {
  text-align: center;
}

.ministry-logo {
  max-width: 300px;
  height: auto;
}
</style>
